import axios from 'axios'

export const getItemTypeValues = (items) => {
  return items.map((item) => {
    return item['value']
  })
}

export const getProjectSizeLabelValues = (projectSize, isRecurring) => {
  switch (true) {
    case projectSize === 'OVER_35_HOURS' && isRecurring:
      return 'LARGE_RECURRING'
    case projectSize === '10_TO_35_HOURS' && isRecurring:
      return 'MED_RECURRING'
    case projectSize === 'UNDER_10_HOURS' && isRecurring:
      return 'SMALL_RECURRING'
    case projectSize === 'OVER_40_HOURS' && !isRecurring:
      return 'LARGE_ONE_TIME'
    case projectSize === '10_TO_40_HOURS' && !isRecurring:
      return 'MED_ONE_TIME'
    case projectSize === 'UNDER_10_HOURS' && !isRecurring:
      return 'SMALL_ONE_TIME'
  }
}

export const sanitizePhoneInput = (phoneNumber: string) => {
  const removeNonIntegerCharacters = /[()-. ]/g
  return phoneNumber.replace(removeNonIntegerCharacters, '')
}

export const populateLocationByZip = async (event, formProperties) => {
  const zipCodeInput = event.target.value
  const { setFieldValue } = formProperties

  setFieldValue(event.target.name, zipCodeInput)

  if (zipCodeInput.length > 4) {
    return await axios
      .get(`https://api.zippopotam.us/us/${zipCodeInput}`)
      .then((data) => {
        const { data: location } = data
        const [place] = location.places
        const city = place['place name'] || ''
        const region = place['state abbreviation'] || ''
        setFieldValue('city', city)
        setFieldValue('region', region)
      })
  }
}
